<!-- Select project button. Hidden when accurating -->
<ion-fab
  vertical="bottom"
  horizontal="center"
  *ngIf="(accurateGroupPositions$ | async) === false && (accurateDevicePosition$ | async) === false"
  (mousedown)="presentDrawer()"
>
  <ion-button expand="block" shape="round" class="select-btn">
    <div class="subtext-btn">
      <ion-spinner *ngIf="(projects$ | async)?.loading || (owners$ | async)?.loading || (loading$ | async)! > 0"></ion-spinner>
      <ion-text *ngIf="(loading$ | async)! > 0">
        <span class="subtext-loading">
          Loading project <b>{{projectName}}</b>
          <span *ngIf="isAdmin">
            <br /> from <b>{{ownerName}}</b>
          </span>
        </span>
      </ion-text>
      <ion-text *ngIf="(loading$ | async)! > 0">Cancel</ion-text>
      <div *ngIf="!(loading$ | async)!">
        <ion-text *ngIf="!!projectName">{{projectName}}</ion-text>
        <p class="subtext-button" *ngIf="!!ownerName">{{ownerName}}</p>
      </div>
      <ion-text *ngIf="!projectName && !(loading$ | async)! && !(projects$ | async)?.loading && !(owners$ | async)?.loading">Project not selected</ion-text>
    </div>
  </ion-button>
</ion-fab>

<!-- Project select -->
<ion-drawer style="padding: 0 10px;">
  <div hide-on-bottom style="position: relative;margin-top: 10px;">
    <ion-item lines="none">
      <ion-text *ngIf="isAdmin">
        Select owner and project
      </ion-text>
      <ion-text *ngIf="!isAdmin">
        Select project
      </ion-text>
    </ion-item>
    <ion-item *ngIf="isAdmin">
      <app-owner-select></app-owner-select>
    </ion-item>
    <ion-item>
      <app-project-select></app-project-select>
    </ion-item>
  </div> 
</ion-drawer>
